import axiosInstance from "../config/axiosInstance";
import { APIROUTE } from "../config/config";

export const loginService = async (payload) => {
  return (await axiosInstance.post(APIROUTE.login, payload)).data;
};

export const createUserService = async (payload) => {
  return (await axiosInstance.post(APIROUTE.admin, payload)).data;
};

export const getUserService = async (signal) => {
  return (await axiosInstance.get(`${APIROUTE.admin}`, signal)).data; 
}

export const createUserfundService = async (payload) => {
  console.log(payload);
  return (await axiosInstance.post(`${APIROUTE.userfundbytype}`, payload)).data; 
}

export const getUserfundService = async (signal, userId) => {
  return (await axiosInstance.get(`${APIROUTE.userfundbytype}/${userId}`, signal)).data; 
}

export const getHistoryService = async (signal, startDate, endDate, userId) => {
  return (await axiosInstance.get(`${APIROUTE.userfundhistory}?startDate=${startDate}&endDate=${endDate}&userId=${userId}`, signal)).data; 
}

export const updateUserfundService = async (payload) => {

  let filteredPayload = {
    "amount": payload.amount
}

  console.log('userId;', payload.userId)
  console.log('userTransferTypeId;', payload.userTransferTypeId)
  console.log('transferTypeId;', payload.transferTypeId)
  console.log('payload;', payload.amount)

  return (await axiosInstance.put(`${APIROUTE.userfundbytype}/userTransferTypeId/${payload.userTransferTypeId}/userId/${payload.userId}/transferTypeId/${payload.transferTypeId}`, filteredPayload )).data; 
}

export const updateUserService = async (payload) => {
    let filteredPayload = {
        "username": payload.username,
        "name": payload.name,
        "role": payload.role,
        "sharePercents" : payload.sharePercents
    }
    return (await axiosInstance.put(`${APIROUTE.admin}/${payload.userId}`, filteredPayload)).data;
};

export const resetPasswordService = async (payload) => {
  let filteredPayload = {
    "userId": payload.userId,
    "password": payload.newPassword
  }
  return (await axiosInstance.put(`${APIROUTE.admin}/changePassword/${payload.userId}`, filteredPayload)).data;
}